import CookieConsent from "./CookieConsent"

export default CookieConsent
